module.exports = __webpack_public_path__ + "img/111.waiting_time_for_service.c6eec224.svg";